import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../ui/accordion";
import { Reveal, SectionHeading } from "../common";
import { FAQS } from "../../data/site";

const Faq = () => (
  <section id="faq" className="py-24 md:py-32 bg-white scroll-mt-20" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-5 md:px-10">
      <Reveal>
        <SectionHeading overline="Good to Know" title="Frequently asked questions." />
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-border"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl font-semibold text-jet-ink py-6 hover:no-underline hover:text-jet-teal [&[data-state=open]]:text-jet-teal">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-jet-ink/70 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
